export const SET_NOTES_LIST_BSCROLL = 'SET_NOTES_LIST_BSCROLL' ;

export const SET_LOADING = 'SET_LOADING' ;

export const SET_QRCODE_POLLING = 'SET_QRCODE_POLLING' ;